/* TESSI Ratgeber-Seiten: gemeinsamer Fahrzeug- und Lackfarben-Zustand fuer alle tg-*-Sections.
   - Fahrzeugliste kommt aus <script type="application/json" data-tg-vehicles> (Hero-Section).
   - Sichtbarkeit: [data-tg-show="key1 key2"] ist nur beim aktiven Fahrzeug sichtbar.
   - Eigener Speicher tessi_guide_vehicle. tessi_vehicle (Fahrzeugmerkung des Shops) wird nur GELESEN,
     nie geschrieben: dessen Format gehoert tessi-vehicle.js, und die Kompletträder-Seiten sollen
     keine Vorauswahl bekommen, die der Kunde nicht selbst getroffen hat. */
(function () {
  if (window.TessiGuide) return;

  var STORE_KEY = 'tessi_guide_vehicle';
  var SHOP_MAP = {
    'Model Y Standard 2026+': 'my-standard',
    'Model Y Premium 2025-2026': 'my-premium',
    'Model Y 2025-2026 Performance': 'my-performance',
    'Model 3 2024-2026': 'm3-standard',
    'Model 3 2026 Standard Hinterradantrieb': 'm3-standard',
    'Model 3 2023-2026 Performance': 'm3-performance'
  };

  /* Modellwahl der Kategorieseiten (sections/vehicle-collection.liquid, Checkbox-Wert = vehicles_model).
     Nur LESEN: der Ratgeber folgt der Kategorie, klickt dort aber nie selbst etwas an (Rabatt-/Sensor-Dialoge).
     Mehrere Kandidaten: steht der Ratgeber schon auf einem davon, bleibt er dort. */
  var VC_MAP = {
    'Model Y Standard 2026+': ['my-standard'],
    'Model Y Premium 2025-2026': ['my-premium'],
    'Model 3 2026 Standard Hinterradantrieb': ['m3-standard'],
    'Model 3 Standard 2026+': ['m3-standard'],
    'Model 3 2024-2026': ['m3-standard', 'm3-premium'],
    'Model 3 2023-2026 Performance': ['m3-performance']
  };

  var state = { key: null, chosen: false, paint: null };
  var vehicles = [];

  function readJSON(el) {
    try { return JSON.parse(el.textContent || '[]'); } catch (e) { return []; }
  }

  function loadVehicles() {
    var nodes = document.querySelectorAll('script[data-tg-vehicles]');
    for (var i = 0; i < nodes.length; i++) {
      var list = readJSON(nodes[i]);
      if (list && list.length) { vehicles = list; return; }
    }
  }

  function findVehicle(key) {
    for (var i = 0; i < vehicles.length; i++) if (vehicles[i].key === key) return vehicles[i];
    return null;
  }

  function storageGet(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function storageSet(k, v) {
    try { window.localStorage.setItem(k, v); } catch (e) { /* privat/blockiert: ohne Speicher weiter */ }
  }

  function initialKey() {
    var fromUrl = null;
    try { fromUrl = new URLSearchParams(window.location.search).get('fahrzeug'); } catch (e) { fromUrl = null; }
    if (fromUrl && findVehicle(fromUrl)) return { key: fromUrl, chosen: true };

    var own = storageGet(STORE_KEY);
    var fromCollection = collectionKey(own);
    if (fromCollection) return { key: fromCollection, chosen: true };
    if (own && findVehicle(own)) return { key: own, chosen: true };

    var shop = storageGet('tessi_vehicle');
    if (shop) {
      try {
        var obj = JSON.parse(shop);
        var mapped = obj && SHOP_MAP[obj.key];
        if (mapped && findVehicle(mapped)) return { key: mapped, chosen: true };
      } catch (e) { /* Format unbekannt: ignorieren */ }
    }

    var def = document.querySelector('[data-tg-default-vehicle]');
    var defKey = def ? def.getAttribute('data-tg-default-vehicle') : null;
    if (defKey && findVehicle(defKey)) return { key: defKey, chosen: false };
    return { key: vehicles.length ? vehicles[0].key : null, chosen: false };
  }

  function vcKey(input, current) {
    var val = input.value || '';
    var list = VC_MAP[val];
    if (!list && val === 'Model Y 2021-2024 Performance') {
      /* Gespiegelter Eintrag "Model Y 2025-2026 Performance" traegt denselben Wert, Generation steht in data-vc-gen bzw. im Label. */
      var gen = input.getAttribute('data-vc-gen') || '';
      if (!gen && input.id) {
        var lbl = document.querySelector('label[for="' + input.id + '"]');
        gen = lbl && /2025/.test(lbl.textContent || '') ? 'my-juniper' : '';
      }
      if (gen === 'my-juniper') list = ['my-performance'];
    }
    if (!list) return null;
    for (var i = 0; i < list.length; i++) if (!findVehicle(list[i])) return null;
    return list.indexOf(current) !== -1 ? current : list[0];
  }

  function collectionKey(current) {
    var boxes = document.querySelectorAll('.vc__model-checkbox:checked');
    for (var i = 0; i < boxes.length; i++) {
      var k = vcKey(boxes[i], current);
      if (k) return k;
    }
    return null;
  }

  function setPressed(nodes, test) {
    for (var i = 0; i < nodes.length; i++) nodes[i].setAttribute('aria-pressed', test(nodes[i]) ? 'true' : 'false');
  }

  function apply() {
    var v = findVehicle(state.key);
    if (!v) return;
    var root = document.documentElement;
    root.setAttribute('data-tg-vehicle', v.key);

    var shows = document.querySelectorAll('[data-tg-show]');
    for (var i = 0; i < shows.length; i++) {
      var keys = (shows[i].getAttribute('data-tg-show') || '').split(' ');
      shows[i].hidden = keys.indexOf(v.key) === -1;
    }

    applyBlog(v.key);

    var names = document.querySelectorAll('[data-tg-vname]');
    for (var n = 0; n < names.length; n++) names[n].textContent = v.name;

    setPressed(document.querySelectorAll('[data-tg-family]'), function (b) { return b.getAttribute('data-tg-family') === v.family; });
    setPressed(document.querySelectorAll('[data-tg-pick]'), function (b) { return b.getAttribute('data-tg-pick') === v.key; });

    var groups = document.querySelectorAll('[data-tg-versions]');
    for (var g = 0; g < groups.length; g++) groups[g].hidden = groups[g].getAttribute('data-tg-versions') !== v.family;

    var chosenOnly = document.querySelectorAll('[data-tg-when]');
    for (var c = 0; c < chosenOnly.length; c++) {
      var when = chosenOnly[c].getAttribute('data-tg-when');
      chosenOnly[c].hidden = (when === 'chosen') !== state.chosen;
    }

    var wa = document.querySelectorAll('[data-tg-wa]');
    for (var w = 0; w < wa.length; w++) {
      var num = wa[w].getAttribute('data-tg-wa');
      var txt = (wa[w].getAttribute('data-tg-wa-text') || 'Hallo, ich habe eine Frage zur Passform für mein {fahrzeug}.').split('{fahrzeug}').join(v.name);
      wa[w].setAttribute('href', 'https://wa.me/' + num + '?text=' + encodeURIComponent(txt));
    }
  }

  function applyBlog(key) {
    var secs = document.querySelectorAll('[data-tg-blog]');
    for (var s = 0; s < secs.length; s++) {
      var sec = secs[s];
      var initial = parseInt(sec.getAttribute('data-tg-blog-initial'), 10) || 3;
      /* Erstes Wort des Tags (z. B. "winterkompletträder") im Titel zieht einen Artikel leicht vor. */
      var boost = (sec.getAttribute('data-tg-blog-boost') || '').toLowerCase();
      var cards = sec.querySelector('[data-tg-blog-cards]');
      var fitList = sec.querySelector('[data-tg-blog-fit]');
      var restList = sec.querySelector('[data-tg-blog-rest]');
      if (!cards || !fitList || !restList) continue;
      var items = Array.prototype.slice.call(sec.querySelectorAll('[data-tg-post]'));
      var scored = items.map(function (el, i) {
        var fit = (el.getAttribute('data-fit') || '').split(' ');
        var exp = (el.getAttribute('data-fit-explicit') || '').split(' ').filter(Boolean);
        var score = 0;
        if (exp.indexOf(key) !== -1) score = exp.length === 1 ? 3 : 2;
        else if (fit.indexOf(key) !== -1 || fit.indexOf('all') !== -1) score = 1;
        if (score > 0 && boost) {
          var title = el.querySelector('.tg-post__title');
          if (title && (title.textContent || '').toLowerCase().indexOf(boost) !== -1) score += 0.5;
        }
        return { el: el, score: score, date: parseInt(el.getAttribute('data-date'), 10) || 0, i: i };
      });
      scored.sort(function (a, b) { return (b.score - a.score) || (b.date - a.date) || (a.i - b.i); });
      var shown = 0, fitting = 0, rest = 0;
      scored.forEach(function (o) {
        var chip = o.el.querySelector('[data-tg-post-chip]');
        if (chip) chip.hidden = o.score < 2;
        if (o.score > 0) fitting++;
        if (o.score > 0 && shown < initial) { o.el.classList.remove('tg-post--row'); cards.appendChild(o.el); shown++; }
        else if (o.score > 0) { o.el.classList.add('tg-post--row'); fitList.appendChild(o.el); rest++; }
        else { o.el.classList.add('tg-post--row'); restList.appendChild(o.el); rest++; }
      });
      sec.hidden = fitting === 0;
      var fitGroup = fitList.closest('[data-tg-blog-group]');
      var restGroup = restList.closest('[data-tg-blog-group]');
      if (fitGroup) fitGroup.hidden = !fitList.children.length;
      if (restGroup) restGroup.hidden = !restList.children.length;
      var more = sec.querySelector('[data-tg-blog-more]');
      if (more) more.hidden = rest === 0;
      var count = sec.querySelector('[data-tg-blog-count]');
      if (count) count.textContent = rest;
    }
  }

  function toggleBlog(btn) {
    var sec = btn.closest('[data-tg-blog]');
    var list = sec && sec.querySelector('[data-tg-blog-list]');
    if (!list) return;
    var open = list.hidden;
    list.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var o = btn.querySelector('[data-tg-blog-open]'), c = btn.querySelector('[data-tg-blog-close]');
    if (o) o.hidden = open;
    if (c) c.hidden = !open;
  }

  function applyPaint() {
    if (!state.paint) return;
    setPressed(document.querySelectorAll('[data-tg-paint]'), function (b) { return b.getAttribute('data-tg-paint') === state.paint; });
    var panels = document.querySelectorAll('[data-tg-paint-panel]');
    for (var i = 0; i < panels.length; i++) panels[i].hidden = panels[i].getAttribute('data-tg-paint-panel') !== state.paint;
  }

  function choose(key) {
    if (!findVehicle(key)) return;
    state.key = key;
    state.chosen = true;
    storageSet(STORE_KEY, key);
    apply();
    try { document.dispatchEvent(new CustomEvent('tessi:guide-vehicle', { detail: { key: key } })); } catch (e) { /* alte Browser */ }
  }

  function onClick(e) {
    var t = e.target.closest ? e.target.closest('[data-tg-family],[data-tg-pick],[data-tg-paint],[data-tg-blog-toggle]') : null;
    if (!t) return;
    if (t.hasAttribute('data-tg-blog-toggle')) { toggleBlog(t); return; }
    if (t.hasAttribute('data-tg-pick')) { choose(t.getAttribute('data-tg-pick')); return; }
    if (t.hasAttribute('data-tg-paint')) { state.paint = t.getAttribute('data-tg-paint'); applyPaint(); return; }
    var fam = t.getAttribute('data-tg-family');
    var cur = findVehicle(state.key);
    if (cur && cur.family === fam) { state.chosen = true; storageSet(STORE_KEY, cur.key); apply(); return; }
    for (var i = 0; i < vehicles.length; i++) {
      if (vehicles[i].family === fam) { choose(vehicles[i].key); return; }
    }
  }

  function init() {
    loadVehicles();
    if (!vehicles.length) return;
    var start = initialKey();
    state.key = start.key;
    state.chosen = start.chosen;
    var firstPaint = document.querySelector('[data-tg-paint][aria-pressed="true"]') || document.querySelector('[data-tg-paint]');
    state.paint = firstPaint ? firstPaint.getAttribute('data-tg-paint') : null;
    apply();
    applyPaint();
    document.addEventListener('click', onClick);
    document.addEventListener('change', function (e) {
      var c = e.target;
      if (!c || !c.classList || !c.classList.contains('vc__model-checkbox') || !c.checked) return;
      var k = vcKey(c, state.key);
      if (k && k !== state.key) choose(k);
    });
  }

  window.TessiGuide = { choose: choose, get: function () { return state.key; } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
